import React from 'react';
import {iconName, typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {withMeta, Plugins, Atom} from '@packages/systems/wfdl';
import {
  CART_ERRORS,
  COMMERCE_ERROR_CATEGORY,
} from '@packages/systems/commerce/constants';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {
  getArrayOrElse,
  getInPojo,
  getNumberOrElse,
  getRecord,
  getString,
} from '@packages/utilities/data-utils';

const cartErrorKeys = Object.keys(CART_ERRORS);

const CommerceCartErrorMsg = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const updatedClasses = classes.push('w-cart-error-msg');

    const errorMessagesById = getArrayOrElse(getInPojo(data, ['texts']), [])
      .map((it: unknown) => getRecord(it))
      .reduce<Record<string, unknown>>((acc, text) => {
        if (text) {
          const textKey = getString(getInPojo(text, ['id']));
          if (textKey) {
            acc[textKey] = text.copy;
          }
        }
        return acc;
      }, {});
    const idx = getNumberOrElse(getInPojo(data, ['temp', 'index']), 0);
    const currentMessage = getString(getInPojo(data, ['texts', idx, 'copy']));

    const errorsAttr = cartErrorKeys.reduce<Record<string, unknown>>(
      (acc, errorKey) => {
        const errorMessageId = getString(
          getInPojo(CART_ERRORS, [errorKey, 'id'])
        );
        if (errorMessageId) {
          acc[`data-w-cart-${errorKey.toLowerCase()}-error`] =
            errorMessagesById[errorMessageId];
        }

        return acc;
      },
      {}
    );

    return (
      <div {...generateAttributes(attributes, updatedClasses)} {...errorsAttr}>
        {currentMessage}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Error Message',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  render: CommerceCartErrorMsg,
  dataType: withMeta(
    {
      textStates: CART_ERRORS,
      legacyStatePath: ['commerce'],
      categories: COMMERCE_ERROR_CATEGORY,
    },
    createIntegratedRootAliasInstance(
      qualify(Plugins.name('Commerce'), typeName('MultiTextEditAlias'))
    )
  ),
});

export default config;
